import { ref, watch, } from 'vue';

export default (initialValue, key) => {
  const returnValue = ref(initialValue);
  let storedValue;
  
  storedValue = window.localStorage.getItem(key);

  if (storedValue) {
    returnValue.value = JSON.parse(storedValue);
  }

  watch(returnValue, (val) => {
    window.localStorage.setItem(key, JSON.stringify(val))
  }, {
    deep: true
  })

  return returnValue
}